module.exports = __webpack_public_path__ + "img/sceneca_4.fdec1a75.png";